import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spin, Table, Empty } from 'antd-v5';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Button } from 'antd-v5';
import MessageConfigToday from './MessageConfigToday';
import { formatTodayPaymentDate } from '../helpers/formatTodayPaymentDate';
import '../today.css';

const TodayPayments = props => {
  const [isShown, setIsShown] = useState('');
  const history = useHistory();

  const handleRowClick = record => {
    history.push(`/Payments/details/${record.payment_request_id}`);
  };

  const getStatusText = status => {
    switch (status) {
      case 'PAID_MANUALLY':
      case 'PAID_BY_CC':
      case 'PAID_WITH_APPLE_PAY':
      case 'PAID_WITH_GOOGLE_PAY':
        return 'Client paid payment request';
      case 'VIEWED':
        return 'Client viewed payment request';
      case 'CANCELED':
        return 'Client canceled payment request';
      case 'REFUNDED':
        return 'Client refunded payment request';
      case 'PAYMENT_FAILED':
        return 'No payment method available';
      case 'REFUND_FAILED':
        return 'Payment request failed to refund';
      case 'UNPAID':
        return 'Payment request sent to client';
      default:
        return '';
    }
  };

  const getStatusBadge = status => {
    switch (status) {
      case 'PAID_MANUALLY':
      case 'PAID_BY_CC':
      case 'PAID_WITH_APPLE_PAY':
      case 'PAID_WITH_GOOGLE_PAY':
        return <span className="today-status-badge paid">PAID</span>;
      case 'VIEWED':
        return <span className="today-status-badge viewed">VIEWED</span>;
      case 'CANCELED':
        return <span className="today-status-badge canceled">CANCELED</span>;
      case 'REFUNDED':
        return <span className="today-status-badge refunded">REFUNDED</span>;
      case 'PAYMENT_FAILED':
        return <span className="today-status-badge failed">FAILED</span>;
      case 'REFUND_FAILED':
        return <span className="today-status-badge failed">REFUND FAILED</span>;
      case 'UNPAID':
        return <span className="today-status-badge sent">SENT</span>;
      default:
        return null;
    }
  };

  const columns = useMemo(
    () => [
      {
        title: 'Date',
        dataIndex: 'datetime',
        key: 'datetime',
        width: '15%',
        render: t => formatTodayPaymentDate(t),
      },
      {
        title: 'Amount',
        dataIndex: 'total_amount',
        key: 'total_amount',
        width: '15%',
        render: amount => `$${amount}`,
      },
      {
        title: 'Client Name',
        dataIndex: 'name',
        key: 'name',
        width: '20%',
      },
      {
        title: 'Client Recent Activity',
        dataIndex: 'status',
        key: 'activity',
        width: '25%',
        render: status => getStatusText(status),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: '10%',
        align: 'center',
        render: status => getStatusBadge(status),
      },
      {
        title: 'Message',
        dataIndex: 'message_action',
        key: 'message_action',
        width: '15%',
        align: 'center',
        render: (_, record) => (
          <div className="align-center pos-rel" style={{ maxHeight: '34px' }} onClick={e => e.stopPropagation()}>
            <MessageConfigToday
              keyVar={Math.floor(Math.random() * record.id)}
              msgObj={record}
              setShowPopConfirm={props.setShowPopConfirm}
              initiateTemplates={props.initiateTemplates}
              setIsShown={setIsShown}
              isShown={isShown}
              setSelectedClient={props.setSelectedClient}
            />
          </div>
        ),
      },
    ],
    [props.setShowPopConfirm, props.initiateTemplates, props.setSelectedClient, isShown],
  );

  return (
    <div className="m-btm-35">
      <div className="flex-row-spacebetween-nowrap m-btm-10">
        <span className="fs-15 fw-500">Payments</span>
        <Link to="/all-payments" id="ViewAllPayments">
          <Button type="link" className="cb-link-btn">
            View All
          </Button>
        </Link>
      </div>

      {props.isLoading ? (
        <div className="w-100-P flex-col-center m-top-10">
          <Spin tip="Loading..." size="large" indicator={<LoadingOutlined spin />}>
            <div
              style={{
                padding: 50,
                background: 'rgba(0, 0, 0, 0.1)',
                borderRadius: 8,
              }}
            />
          </Spin>
        </div>
      ) : (
        <Table
          className="today-table"
          columns={columns}
          dataSource={props.data}
          rowKey={record => record.payment_request_id || record.id}
          pagination={false}
          onRow={record => ({
            onClick: () => handleRowClick(record),
            style: { cursor: 'pointer' },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Payments" />,
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({ auth: state.auth, payments: state.payments });
export default connect(mapStateToProps, {})(TodayPayments);
